import scene from "./Scene";
import camera from "./Camera";
import renderer from "./Rendered";
import { useRef, useEffect } from "react";
import "./Orbit.js";
import gltfLoader from "./gltfLoader";
import * as THREE from "three";
import light from "./Light";
import GUI from 'lil-gui';
import { Vector2 } from "three";

const Template = () => {
  const mountRef = useRef(null);

  useEffect(() => {
    //Data from the canvas
    const currentRef = mountRef.current;
    const { clientWidth: width, clientHeight: height } = currentRef;

    //Scene, camera, renderer
    scene.add(camera);

    camera.position.set(-0.2, -0.2, -0.5);
    //Light
    scene.add(light);

    //Grupo
    const Iphone = new THREE.Group();
    camera.lookAt(Iphone.position);

    //video Texture


    //env Map para que lo metalico refleje
    const cubeTextureLoader = new THREE.CubeTextureLoader();
    const enp = cubeTextureLoader.load([
      "./envMap/px.jpg",
      "./envMap/nx.jpg",
      "./envMap/py.jpg",
      "./envMap/ny.jpg",
      "./envMap/pz.jpg",
      "./envMap/nz.jpg",
    ]);

    scene.background = enp;
    //Iphone
    gltfLoader.load(
      "./Models/iphone.gltf",
      (gltf) => {
        while (gltf.scene.children.length) {
          if (gltf.scene.children[0].name !== 'body' && gltf.scene.children[0].name !== 'cameras') {
            gltf.scene.children[0].material.envMap = enp;
            gltf.scene.children[0].material.roughness = 0;
            if(gltf.scene.children[0].name === 'screen'){
              gltf.scene.children[0].material.color.set('#0f0f0f');
            }
          }

          Iphone.add(gltf.scene.children[0]);
        }

        //body
        for (let i = 0; i < Iphone.children[0].children.length; i++) {
          Iphone.children[0].children[i].material.envMap = enp;
          Iphone.children[0].children[i].material.transparent = true;
          if (i === 3) {
            Iphone.children[0].children[i].material.opacity = 0.1;
          }
        }

        //cameras
        for (let i = 0; i < Iphone.children[2].children.length; i++) {
          Iphone.children[2].children[i].material.envMap = enp;
          Iphone.children[2].children[i].material.transparent = true;

        }


        Iphone.scale.set(2, 2, 2);
        scene.add(Iphone);
      }
    );
    const playVideo = () => {

      let video = document.getElementById('video');
      video.play();
    
      let videoTexture = new THREE.VideoTexture(video);
      videoTexture.flipY = false;
      videoTexture.center = new Vector2(0.5, 0.5);
      videoTexture.repeat.set(4.2, 2);
      videoTexture.offset.y = -0.51;
      videoTexture.offset.x = -0.54;
      Iphone.children[7].material.color.set('#ffffff');
      Iphone.children[7].material.map = videoTexture;
      Iphone.children[7].material.roughness = 0.16;

    }

    const stopVideo = () => {

      let videoOff = document.getElementById('video');
      videoOff.pause();
      
    }


    const resetVideo = () => {

      let videoReset = document.getElementById('video');
      videoReset.pause();
      videoReset.play();
      videoReset.addEventListener('play', function () {

        this.currentTime = 0;

      });
      


    }

    const offCell = () => {

      Iphone.children[7].material.map = null;
      Iphone.children[7].material.color.set('#0f0f0f');
      Iphone.children[7].material.roughness = 0;

    }



    renderer.setSize(width, height);
    currentRef.appendChild(renderer.domElement);




    //Resize canvas

    renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
    camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
    camera.updateProjectionMatrix();

    const resize = () => {
      renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
      camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
      camera.updateProjectionMatrix();
    };
    window.addEventListener("resize", resize);




    //Animate the scene
    const animate = () => {

      renderer.render(scene, camera);
      requestAnimationFrame(animate);


    };
    animate();

    //gui
    const gui = new GUI();
    const guiMenu = {

      playYouTube: function () {
        playVideo();
      },
      stopYouTube: function () {
        stopVideo();
      },
      resetYouTube: function () {
        resetVideo();
      },
      off: function () {
        offCell();
      },
    };

    gui.add(guiMenu, 'playYouTube').name('Play');
    gui.add(guiMenu, 'stopYouTube').name('Pause');
    gui.add(guiMenu, 'resetYouTube').name('Reset');
    gui.add(guiMenu, 'off').name('turn off the screen');

    return () => {
      window.removeEventListener("resize", resize);
      currentRef.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{ width: "100%", height: "1080px" }}
    ></div>
  );
};

export default Template;



